import axiosInstance from "../../../../../helpers/axiosConfig"
import config from "../../../../../config"


export const transactionStatus = async (id) => {
    const baseUrl = config.REACT_APP_BASE_URL//process.env.REACT_APP_BASE_URL

    try {
        const response = await axiosInstance.get(
          `${baseUrl}Transaction/${id}`
                
        ) 
         //console.log('Transaction: ', response)
    
         return response
    
      } catch (error) {
        console.error('Service Error:', error)
        // console.error('error response:', error.response)
    
        return error
      }

}


export const changePasswordService = async (data) => {

    const baseUrl = config.REACT_APP_BASE_URL//process.env.REACT_APP_BASE_URL

    try {
        const response = await axiosInstance.put(
          `${baseUrl}Member/ChangePassword`,
          data,
          {
            headers: { 'Content-Type': 'application/json' },
          }
        )
    
         //console.log('forgotPassword response: ', response)
    
         return response
    
      } catch (error) {
        console.error('Service Error:', error)
        // console.error('error response:', error.response)
    
        return error
      }
}